import { NumberField } from './fields';

export type AustralianPassUpConfig = {
  pass_up_start: number;
};

export function AustralianPassUpEditor({
  value,
  onChange,
  readOnly,
}: {
  value: AustralianPassUpConfig;
  onChange: (next: AustralianPassUpConfig) => void;
  readOnly?: boolean;
}) {
  return (
    <div className="max-w-md">
      <NumberField
        label="Pass-up start position"
        hint="1-indexed sibling position at which the direct sponsor finally earns. Positions below this pass up to an ancestor whose own position is also ≥ this value. Legacy default = 3 (first 2 directs pass up)."
        value={value.pass_up_start}
        disabled={readOnly}
        onChange={(v) => onChange({ pass_up_start: Math.max(1, v ?? 1) })}
        min={1}
        max={20}
        step={1}
      />
    </div>
  );
}

export function emptyAustralianPassUpConfig(): AustralianPassUpConfig {
  return { pass_up_start: 3 };
}
